import { RoundButton } from "../../../../../assets/styles/RoudeButton";
import { Modal } from "../../../../../components/Modal";
import { Comment } from "../../../../../components/Comment/index";

import sendIcon from "../../../../../assets/imgs/send_icon.svg";

import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { PostContext } from "../../../../../providers/PostContext";
import { Loading } from "../../../../../components/LoadingProps/loading";
import { UserContext } from "../../../../../providers/UserContext";
import { CommentModalStyled } from "./styles";
import { Link } from "react-router-dom";

type iCommentModal = {
  postId: number | null;
  setShowComments: Dispatch<SetStateAction<boolean>>;
};

export const CommentModal = ({ postId, setShowComments }: iCommentModal) => {
  const { comments, getPostComments, createPostComment } =
    useContext(PostContext);
  const { user } = useContext(UserContext);

  const [loading, setLoading] = useState(true);
  const [loadingComment, setLoadingComment] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMoreComments, setHasMoreComments] = useState(true); // Estado para controlar se há mais comentários para carregar

  const messageRef = useRef<HTMLInputElement>(null);

  // Função para carregar mais comentários quando o botão "Carregar mais" for clicado
  const loadMoreComments = async () => {
    try {
      setLoadingComment(true);
      const response = await getPostComments(postId, page + 1); // Carrega a próxima página de comentários

      if (
        (response && response?.count <= 10) ||
        (response && response.count >= 10 * page)
      ) {
        setHasMoreComments(false); // Se não houver mais comentários, desativa o botão
      }
      setPage((prevPage) => prevPage + 1); // Incrementa o número da página
      setLoadingComment(false);
    } catch (error) {
      console.error("Erro ao carregar mais comentários:", error);
      setLoadingComment(false);
    }
  };

  // Função para criar um comentário
  const handleComment = async (postId: number | null) => {
    try {
      createPostComment(
        postId,
        messageRef.current ? messageRef.current.value : "",
        1
      ); // Sempre cria um novo comentário na primeira página
      if (messageRef.current) {
        messageRef.current.value = "";
      }
    } catch (error) {
      console.error(`Erro ao criar um comentário em um post`, error);
    }
  };

  // Carregar comentários iniciais quando o componente montar
  useEffect(() => {
    const fetchComments = async () => {
      setLoading(true);

      const response = await getPostComments(postId, page);
      if (response && response?.count <= 10) {
        setHasMoreComments(false); // Se não houver mais comentários, desativa o botão
      }

      setLoading(false);
    };

    fetchComments();
  }, [postId]);

  return (
    <Modal showModal={setShowComments}>
      <CommentModalStyled>
        <div id="comments">
          {loading ? (
            <Loading $width="50px" />
          ) : (
            <>
              {comments && !!comments.raw.length ? (
                comments.raw.map((comment) => (
                  <Comment
                    key={comment.id}
                    comment={comment}
                    page={page}
                    postId={postId}
                  />
                ))
              ) : (
                <div>Pipoque o comentário aí, moral</div>
              )}
              {loadingComment ? (
                <Loading $width="50px" />
              ) : (
                hasMoreComments && (
                  <button onClick={loadMoreComments}>
                    Carregar mais comentários
                  </button>
                )
              )}
            </>
          )}
        </div>
        {user &&
          (<div className="model-footer">
            <div className="user-img">
              <abbr title="Imagem do perfil">
                <Link to={`/perfil/${user?.username}`}>
                  <img src={user?.image} alt="Imagem do perfil" />
                </Link>
              </abbr>
            </div>
            <div className="message">
              <input type="text" ref={messageRef} />
            </div>
            <abbr title="Enviar comentário">
              <RoundButton onClick={() => handleComment(postId)}>
                <img src={sendIcon} alt="send icon" />
              </RoundButton>
            </abbr>
          </div>)
        }

      </CommentModalStyled>
    </Modal>
  );
};
